import React from 'react';
import Typing from './Typing';
import profile from './me.jpg'
import hand from './Hand.gif'
import './style.css'
import fade from '../../Fade';

const Intro = () => {

    return (
        <div   className='pt-52 pl-4 pr-4 pb-52 tsparticles'>
            <div data-aos={fade[Math.floor(Math.random() * fade.length)]}   data-aos-offset="200" data-aos-easing="ease-in-sine" data-aos-duration="700" className='text-center text-white'>
                <div className='flex justify-center text-2xl sm:text-4xl font-bold'>
                    Hi <img src={hand} className='align-middle w-[35px]' alt="" /> , I'm RAKIB
                </div>
                <div className="avatar m-4">
                    <div className="w-44 sm:w-52 md:w-72 mask mask-hexagon">
                        <img src={profile} />
                    </div>
                </div>
                <Typing />
            </div>
        </div>
    );
};

export default Intro;